/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'es6-promise/auto'

// 3rd Party Libraries
import VueMobileDetection from "vue-mobile-detection";

// In house components
import CouponForm from './components/CouponForm'
import RecentlyWatchedSlider from "./components/Sliders/RecentlyWatchedSlider";
import SocialLoginButtons from './components/Login/SocialLoginButtons'
import ChargebeeCheckoutLauncher from './components/Chargebee/CheckoutLauncher'

// Set Vue globally
// window.Vue = Vue;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
new Vue({
    el: '#app',
    components: {
        CouponForm,
        RecentlyWatchedSlider,
        ChargebeeCheckoutLauncher,
        SocialLoginButtons
    },
});

/**
 * Setup our Vue App and inject dependencies
 */
Vue.use(Vuex, VueAxios, axios, VueMobileDetection)

// Setup Axios to be used in all components
Vue.prototype.$http = axios;
const token = localStorage.getItem('token')
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}
